import React from 'react';

class PageLoading extends React.Component{
    render() {
        return (
            <div style={{ paddingTop: 300, textAlign: 'center' }} />
        )
    }
}

export default PageLoading;
